///<reference path="../../employee/sections/employee.shared.section.ts"/>
module Meevo.Plugins.Student {
    "use strict";

    /**
     * Location Section of Employee
     */
    export class SharedSection extends Meevo.Plugins.Employee.SharedSection {
        public get auditNounForSave() {
            return Model.NounEnum.StudentShared;
        }
    }
}